/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_A3dInputs */

const en_mk_sol_agensi_a3d = /** @type {(inputs: Mk_Sol_Agensi_A3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chases invoices that fall due and totals hours per client at month end.`)
};

const id_mk_sol_agensi_a3d = /** @type {(inputs: Mk_Sol_Agensi_A3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengingatkan invoice yang jatuh tempo dan merekap jam kerja per klien di akhir bulan.`)
};

/**
* | output |
* | --- |
* | "Chases invoices that fall due and totals hours per client at month end." |
*
* @param {Mk_Sol_Agensi_A3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_a3d = /** @type {((inputs?: Mk_Sol_Agensi_A3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_A3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_a3d(inputs)
	return en_mk_sol_agensi_a3d(inputs)
});